var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 24,
    viewBox: "0 0 16 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8.5,
    r: 3,
    stroke: "#0E0333"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1108 8.56345C15.1108 9.30517 14.8365 10.3169 14.3544 11.4996C13.8774 12.67 13.2175 13.9595 12.4913 15.2406C11.0394 17.802 9.34338 20.2929 8.37538 21.6668C8.1876 21.9333 7.81186 21.9333 7.62408 21.6668C6.65608 20.2929 4.96009 17.802 3.50812 15.2406C2.78193 13.9595 2.12204 12.67 1.64504 11.4996C1.163 10.3169 0.888672 9.30517 0.888672 8.56345C0.888672 4.63612 4.0724 1.45239 7.99973 1.45239C11.9271 1.45239 15.1108 4.63612 15.1108 8.56345Z",
    stroke: "#0E0333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLocation);
export default __webpack_public_path__ + "static/media/icon-location.b2cc7654a41ffb23f698a5a224c3c371.svg";
export { ForwardRef as ReactComponent };